import queryString from 'query-string'
import 'nodelist-foreach-polyfill'
import 'formdata-polyfill'

window.addEventListener('DOMContentLoaded', () => {
  const checkRegion = (regionId, checked) => {
    const prefectureInputs = document.querySelectorAll(`.js-prefecture[data-region-id="${regionId}"]`)
    prefectureInputs.forEach((el) => el.checked = checked)
  }

  const checkPrefecture = (regionId, checked) => {
    const regionInput = document.querySelector(`.js-region[data-region-id="${regionId}"]`)
    if (checked) {
      const prefectureInputs = document.querySelectorAll(`.js-prefecture[data-region-id="${regionId}"]:not(:checked)`)
      if (prefectureInputs.length === 0) {
        regionInput.checked = true
      }
    } else {
      regionInput.checked = false
    }
  }

  const clearAllFormData = () => {
    allCheckboxes.forEach((el) => el.checked = false)
    allRadios.forEach((el) => el.checked = false)
  }

  const setConditionsCountNum = () => {
    const formData = new FormData(conditionForm)
    let count = 0
    for (const [_, v] of formData.entries()) {
      if (v && v !== '') count++
    }
    conditionsCounts.forEach((el) => el.textContent = count)
  }

  const changeOrderPer = (value, type) => {
    const params = queryString.parse(location.search.substr(1), { arrayFormat: 'bracket' })
    params[type] = value
    const query = queryString.stringify(params, { arrayFormat: 'bracket' })
    const url = [location.protocol, '//', location.host, location.pathname, '?', query].join('')
    window.location.href = url
  }

  const regionInputs = document.querySelectorAll('.js-region')
  const prefectureInputs = document.querySelectorAll('.js-prefecture')
  const submitButtons = document.querySelectorAll('.js-submit')
  const clearButton = document.querySelector('.js-clear')
  const conditionsCounts = document.querySelectorAll('.js-conditions-count')
  const orderSelects = document.querySelectorAll('.js-order')
  const perSelects = document.querySelectorAll('.js-per')
  const allCheckboxes = document.querySelectorAll('input[type=checkbox]')
  const allRadios = document.querySelectorAll('input[type=radio]')

  const conditionForm = document.getElementById('condition-form')
  const nameForm = document.getElementById('name-form')

  regionInputs.forEach((el) => {
    el.addEventListener('change', (e) => {
      checkRegion(e.target.dataset.regionId, e.target.checked)
    })
  })

  prefectureInputs.forEach((el) => {
    el.addEventListener('change', (e) => {
      checkPrefecture(e.target.dataset.regionId, e.target.checked)
    })
  })

  submitButtons.forEach((el) => {
    const target = el.dataset.target
    if (target == 'condition-form'){
      el.addEventListener('click', onConditionFormSubmit);
    } else if (target == 'name-form') {
      el.addEventListener('click', onNameFormSubmit)
    } else if (target == 'stored-condition-form'){
      el.addEventListener('click', () => {
        const form = document.querySelector(`#${target}`)
        form.submit()
      })
    }
  });

  function onsubmit(form) {
    const formData = new FormData(form);
    const url = new URL(form.action, window.location.origin);

    // Remove all existing search parameters
    url.search = '';

    // Append only non-empty parameters
    for (const [key, value] of formData.entries()) {
        if (value.trim() !== '') {
            url.searchParams.append(key, value);
        }
    }

    window.location.href = url.toString();
  }

  conditionForm.addEventListener('submit', onConditionFormSubmit);
  nameForm.addEventListener('submit', onNameFormSubmit);

  function onNameFormSubmit(e) {
    e.preventDefault();
    onsubmit(nameForm);
  }

  function onConditionFormSubmit(e) {
    e.preventDefault();
    onsubmit(conditionForm)
  }

  clearButton.addEventListener('click', () => {
    clearAllFormData()
    setConditionsCountNum()
  })

  conditionForm.addEventListener('change', () => setConditionsCountNum())
  window.addEventListener('pageshow', () => {
    setConditionsCountNum()
  })

  orderSelects.forEach((el) => {
    el.addEventListener('change', (e) => changeOrderPer(e.target.value, 'order'))
  })

  perSelects.forEach((el) => {
    el.addEventListener('change', (e) => changeOrderPer(e.target.value, 'per'))
  })
})
